import { useMemo } from 'react';
import './AdminDigitArr.css';

const AdminDigitArrLimit = ({ numarray, handleClickOpen, firstDigit, lastDigit, currentDigit, limit, limitArr }) => {


  // Precompute digit data
  const digitData = useMemo(() => {
    if (!numarray) return [];
    return numarray.filter(digit => parseInt(digit) >= firstDigit && parseInt(digit) < lastDigit).map(digit => {
      return {
        digit
      };
    });
  }, [numarray, firstDigit, lastDigit]);
  
  return (
    <div className='column'>
      {digitData.map((data, index) => (
        <div className='dataBox' key={index}>
          <p className='digitBox' style={{backgroundColor:currentDigit?.includes(data.digit)? "black":''}} onClick={() => handleClickOpen(data.digit)}>
            {data.digit}
          </p>
          <p style={{paddingTop:3}} className={`amountBox`}>
            {
    Array.isArray(limitArr)
      ? limitArr.find(item => item.digit === data.digit)?.amount || limit
      : limit
  }
          </p>
        </div>
      ))}
    </div>
  );
};

export default AdminDigitArrLimit;
